// extracted by mini-css-extract-plugin
export default {"mydpd-navbar-brand":"Brand_mydpd-navbar-brand__RKdpD"};